import axios from 'axios'
//
// initial state
const state = {
  steps: [],
  edit: true,
  showResult: false,
  currentStepIndex: 0,
  currentChoice: null,
  result: {},
  status: 'idle' // loading | success | error | idle
}

// actions
const actions = {
  getBuyGuide ({ commit }, { api, params, callback }) {
    commit('setStatus', 'loading')
    !!api &&
    axios.get(api)
      .then(response => {
        const data = !!response && response?.data?.Data
          ? response.data.Data
          : null

        const result = !!data && data?.Result
          ? data.Result
          : null

        // console.log('GET BUYGUIDE API RESPONSE:', data, result)
        commit('setBuyGuide', data)
        commit('setResult', result)
        commit('setStatus', 'success')
      })
      .catch(error => {
        console.log('GET BUYGUIDE ERROR:', error)
        commit('setStatus', 'error')
      })
      .finally(() => {
        commit('setStatus', 'idle')
        if(!!callback) {
          callback();
        }
      })
  },
}
// getters
const getters = {
  getOptionByIndex: (state) => (stepIndex, optionIndex) => {
    return state.steps[stepIndex].Options[optionIndex];
  },
  getCurrentStep: (state) => (currentStepIndex) => {
    return state.steps[currentStepIndex];
  },
  getCurrentChoice: (state) => (currentStepIndex) => {
    return !state.steps[currentStepIndex] ? null : state.steps[currentStepIndex].Choice;
  }
}

// mutations
const mutations = {
  setSettings (state, data) {
    !data || data === [] || data === 'undefined'
      ? state.settings = []
      : state.settings = {
        totalItems: data.TotalItems,
        pageCount: data.PageCount,
        pageItems: data.PageItems
      }
  },

  setCurrentStepIndex(state, data) {
    !data || data === [] || data === 'undefined'
      ? state.currentStepIndex = 0
      : state.currentStepIndex = data.currentStepIndex
  },

  incrementStepIndex (state) {
    state.currentStepIndex++;
  },

  setBuyGuide (state, data) {
    !data || data === [] || data === 'undefined'
      ? state.steps = []
      : state.steps = data.Steps
  },

  setResult (state, data) {
    !data || data === {} || data === 'undefined'
      ? state.result = {}
      : state.result = data
  },

  toggleShowResult (state, data) {
    !data || data === 'undefined'
    ? state.showResult = !state.showResult
    : state.showResult = data.showResult
  },

  toggleStepIsComplete (state, data) {
    const { stepIndex, isComplete } = data;
    const currentStep = state.steps[stepIndex];
    currentStep.IsComplete = isComplete;
  },

  setSelectedOption (state, data) {
    const { option } = data;
    const stepIndex = state.steps.map(step => step.Type).indexOf(option.Type);
    const currentStep = state.steps.filter(step => step.Type === option.Type)[0];
    const options = [];
    currentStep.Options.forEach((item) => {
      item.Selected = (item.Id === option.Id);
      options.push(item);
    });
    currentStep.Options = options;
    // set choice
    currentStep.Choice = { Id: option.Id }
    state.steps.splice(stepIndex, 1, currentStep);

    state.currentChoice = { ...currentStep.Choice };
  },

  setDimensions (state, data) {
    const { option, dimensions } = data;
    const stepIndex = state.steps.map(step => step.Type).indexOf(option.Type);
    const currentStep = { ...state.steps.filter(step => step.Type === option.Type)[0] };
    const currentOption = { ...currentStep.Options.filter(x => x.Id === option.Id)[0] };
    // console.log('setDimensions', currentOption.Header)
    currentOption.Dimensions.widths.forEach((dimension) => {
      dimension.selected = dimension.value === dimensions.width;
    });
    currentOption.Dimensions.heights.forEach((dimension) => {
      dimension.selected = dimension.value === dimensions.height;
    });

    currentStep.Choice.Width = dimensions.width;
    currentStep.Choice.Height = dimensions.height;
    // state.steps.splice(stepIndex, 1, currentStep);

    state.currentChoice = { ...currentStep.Choice };
  },

  setStatus (state, value) {
    state.status = value
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
